import coverPageBody from './coverPageBody';
import coverPageHeader from './coverPageHeader';
import messageBody from './messageBody';
import endPageBody from './endPageBody';

export default {
	coverPageBody,
	coverPageHeader,
	messageBody,
	endPageBody
};
